import React, {Component} from "react";
import Section from "./../layouts/Section";
import {Link} from "react-router-dom";
import PackageExpired from "../layouts/PackageExpired";
import helpers from './../../networking/Helpers';
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import {
    PullToRefresh,
    PullDownContent,
    ReleaseContent,
    RefreshContent
  } from "react-js-pull-to-refresh";
  
class AbsenceList extends Component {
    constructor(props) {
        super(props);
        var neweDate=new Date().toISOString();
        neweDate=neweDate.split("T");
        
        var current = new Date(); //'Mar 11 2015' current.getTime() = 1426060964567
        var tomorrow = new Date(current.getTime() + 86400000*365); // + 1*365 day in ms
        tomorrow = tomorrow.toISOString().split("T");

        this.state={
          data_list:[],
          start_date:neweDate[0],
          end_date: tomorrow[0],
          date_range:365, //  in days
          total_count: -1,
          emp_edit:1,
            absence_type_id: '',
            absence_type_name:'',
            amount:'',
            payment_type:'',
            assign_users:[],
            current_url:'/absence-list/'
        }
    }

    componentDidMount(){
        this.getAbsenceList(this.state.start_date, this.state.end_date);
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    handleRefresh() {
        return new Promise(resolve => {
            this.getAbsenceList(this.state.start_date, this.state.end_date, resolve);
        });
      }

    getAbsenceList(start,end, resolve){
      var formData=new FormData();
      formData.append("department",localStorage.getItem('department_id'));
      formData.append("start_date",start);
      formData.append("end_date",end);
      post(Constent.GETABSENCE,formData).then(response=>{
          if(response.status===1){
            this.setState({
                data_list:response.data,
                total_count:response.data.length,
            })
          }else{
            Alert.error({title: response.message});
          }

          if(resolve) {
            resolve();
          }
      })
    }

    addData = () => {
        var formData=new FormData();
        formData.append("user_id", localStorage.getItem('userid'));
        formData.append("absence_type_name",this.state.absence_type_name);
        formData.append("department",localStorage.getItem("department_id"));
        formData.append("payment_type",this.state.payment_type);
        formData.append("amount",this.state.amount);
        post(Constent.ADDABSENCETYPE,formData).then(response =>{
          if(response.status===1){
            this.getAbsenceList(this.state.start_date,this.state.end_date);
            window['modalClose']('#add-modal');
            Alert.success({title: response.message});
          }else{
            Alert.error({title: response.message});
          }   
        })
    };

    updateData = () => {
        var formData=new FormData();
        formData.append("absence_type_id",this.state.absence_type_id);
        formData.append("user_id", localStorage.getItem('userid'));
        formData.append("absence_type_name",this.state.absence_type_name);
        formData.append("department",localStorage.getItem("department_id"));
        formData.append("payment_type",this.state.payment_type);
        formData.append("amount",this.state.amount);
        post(Constent.UPDATEABSENCETYPE,formData).then(response =>{
          if(response.status===1){
            this.getAbsenceList(this.state.start_date,this.state.end_date);
            window['modalClose']('#edit-modal');
            Alert.success({title: response.message});
          }else{
            Alert.error({title: response.message});
          }   
      })
  };

    startdt=()=>{
        var str=this.state.start_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }
    enddt=()=>{
        var str=this.state.end_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }

    selectDropdown = (payment_type) => {
        this.setState({payment_type:payment_type});
    };

    switchScreen = (url) => {
        this.setState({current_url:url});
        this.props.history.push(url);
    };
    render() {
        const { t } = this.props;
        return (
            <Section title={t('lang.absence_sc_personal_absence')}>
                { helpers.isIntegrationExpired(3) ? <PackageExpired /> : '' }
                <div className="timeregistraion-userlistpage page-title mg-top-50">
                    <div className="container">
                        <div className="row action-row">
                            <div className="col-6">
                                <p>{t('lang.filter_text_period')}: { this.startdt().substring(3, 10)} - {this.enddt().substring(3, 10)}</p>
                            </div>
                            <div className="col-6 text-right">
                                <p className="label" htmlFor="sortBy">{t('lang.link_text__go_to')}</p>
                            </div>
                        </div>
                        <div className="row action-row">
                            <div className="col-6">
                                <span className="previous"
                                onClick={() => {
                                  this.setState({end_date:this.state.start_date});    
                                  var date1 = new Date(this.state.start_date);
                                    date1.setDate(date1.getDate()-this.state.date_range);
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({start_date:neweDate[0]});
                                    this.getAbsenceList(neweDate[0],this.state.start_date);
                                    }}>{t('lang.filter_text_prev')}</span>
                                <span className="next"
                                    onClick={() => {
                                    this.setState({start_date:this.state.end_date}); 
                                    var date1 = new Date(this.state.end_date);
                                    date1.setDate(date1.getDate() + this.state.date_range)
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({end_date:neweDate[0]});
                                    this.getAbsenceList(this.state.end_date,neweDate[0]);
                                    }}>{t('lang.filter_text_next')}</span>
                            </div>
                            <div className="col-6 text-right">
                                <select id="sortBy" 
                                value={this.state.current_url}
                                onChange={e => { this.switchScreen(e.target.value)}} >     
                                    <option value="/absence-list/">{t('lang.absence_sc_personal_absence')}</option>
                                    <option value="/public-holiday/">{t('lang.absence_sc_public_holiday')}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <PullToRefresh
                pullDownContent={<PullDownContent label='' />}
                releaseContent={false}
                refreshContent={<RefreshContent />}
                pullDownThreshold={2}
                onRefresh={this.handleRefresh}
                triggerHeight={500}
                startInvisible= {true}
            >    
                <div className="timeregistraion-userlistpage transaction-area pd-top-15 mg-bottom-40">
                    {this.state.total_count < 0 ? <p className="text-center">{t('lang.common_text_loading') }</p> : '' }
                    {this.state.data_list.map(({ absence_type_id, absence_type_name, amount,assign_users,payment_type,assign_count}) => (
                        <div className="single-goal" key={absence_type_id}>
                            
                            <div className="row" style={{margin:10}}>
                                <div className="col-8">
                                    <Link to={'#'}
                                        onClick={()=> { 
                                          this.setState({
                                            absence_type_id: absence_type_id,
                                            absence_type_name:absence_type_name,
                                            amount:amount,
                                            payment_type:payment_type
                                            })
                                            window['modalOpen']('#edit-modal');
                                        }} 
                                     >
                                    <h6 className="text-overflow">{absence_type_name}</h6>
                                    <span>{payment_type === 1 ? t('lang.absence_sc_company_paying') : t('lang.absence_sc_staff_paying')} <strong>{payment_type === 1 ? amount + 'DKK'  : ''}</strong></span>
                                    </Link>
                                </div>
                                <div className="col-2 center">
                                    <Link to={'/absence-userlist/'+absence_type_id}>
                                    {assign_count.total_absence > 0 ?
                                       <> <span className="approve-badge">{assign_count.approve_absence}</span><span className="not-approve-badge">{assign_count.not_approve_absence}</span></>
                                    : assign_count.total_absence }
                                    </Link>
                                </div>
                                <div className="col-2 center">
                                    <Link to={'/absence-userlist/'+absence_type_id}>
                                        <i className="la la-angle-right" style={{fontSize:35,color:'rgb(169 169 178)'}}></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* transaction End */}
                </PullToRefresh>

                {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                                <div className="col-2">
                                {(this.state.emp_edit === 1) ?    
                                <Link to={'#'}  
                                data-toggle="modal" data-target="#add-modal"
                                onClick={()=>{
                                  this.setState({
                                    absence_type_name:'',
                                    amount:'',
                                    payment_type : 1
                                })
                                }}
                                >
                                    <i className="las la-cog setting-icon"></i>
                                </Link>
                                : ''}
                                </div>
                                <div className="col-8">
                                    <div><span>{t('lang.absence_sc_total_absence')}: {this.state.total_count} </span></div>
                                </div>
                                <div className="col-2">
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            {/* Footer End */}

                
            {/*  add-modal start */}
            <div id="add-modal" className="modal modal-top fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.absence_sc_add_absence')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.absence_sc_absence_type_name')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.absence_type_name} 
                                    onChange={e => { this.setState({absence_type_name: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.absence_sc_payment_type')}</span>
                                <div className="input-group mb-4">
                                    <select value={this.state.payment_type} 
                                    className="form-control form-control-lg"
                                     onChange={e => { this.selectDropdown(e.target.value)}}>
                                        <option value='1'>{t('lang.absence_sc_company')}</option>
                                        <option value='2'>{t('lang.absence_sc_staff')}</option>
                                      </select>
                                </div>
                                { ( (this.state.payment_type === 1) || (this.state.payment_type === '1')) ? 
                                <>
                                <span className="label">{t('lang.absence_sc_amount')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.amount} 
                                    onChange={e => { this.setState({amount: e.target.value})}} />
                                </div> </>
                                : ''}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.addData()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>    
            {/*  edit-modal start */}
            <div id="edit-modal" className="modal modal-top fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.absence_sc_edit_absence')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.absence_sc_absence_type_name')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.absence_type_name} 
                                    onChange={e => { this.setState({absence_type_name: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.absence_sc_payment_type')}</span>
                                <div className="input-group mb-4">
                                    <select value={this.state.payment_type} 
                                    className="form-control form-control-lg"
                                     onChange={e => { this.selectDropdown(e.target.value)}}>
                                        <option value='1'>{t('lang.absence_sc_company')}</option>
                                        <option value='2'>{t('lang.absence_sc_staff')}</option>
                                      </select>
                                </div>
                                { ( (this.state.payment_type === 1) || (this.state.payment_type === '1')) ? 
                                <>
                                <span className="label">{t('lang.absence_sc_amount')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.amount} 
                                    onChange={e => { this.setState({amount: e.target.value})}} />
                                </div> </>
                                : ''}
                            </div>
                        </div>
                        <div className="modal-footer">
                        {(this.state.emp_edit === 1) ? <>
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateData()}}>{t('lang.modal_btn_save')}</button>
                            </>
                         : ''}   
                        </div>
                    </div>
                </div>
            </div>
            </Section>
        );
    }
}

export default withTranslation('common')(AbsenceList);